// src/router/index.js
import Vue from 'vue';
import Router from 'vue-router';

import Home from '@/views/Home.vue';
import SolutonModule from '@/views/SolutionModule.vue';
import CustomerCase from '@/views/CustomerCase.vue'
import ContactUs from '@/views/ContactUs.vue'
import AboutUs from '@/views/AboutUs.vue'
import CaseDetails from '@/views/CaseDetails.vue'

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/Solution',
      name: 'Solution',
      component: SolutonModule,
    },
    {
      path: '/Case',
      name: 'Case',
      component: CustomerCase,
    },
    {
      path: '/AboutUs',
      name: 'AboutUs',
      component: AboutUs,
    },
    {
      path: '/ContactUs',
      name: 'ContactUs',
      component: ContactUs,
    },
    {
      path: '/CaseDetails',
      name: 'CaseDetails',
      component: CaseDetails,
    },
  ],
});

// 👇 针对你的项目定制的置顶逻辑
router.afterEach(() => {
  setTimeout(() => {
    // 1. 置顶 .content 容器（你的项目真正的滚动主体）
    const scrollContainer = document.querySelector('.content');
    if (scrollContainer) {
      scrollContainer.scrollTop = 0;
    }
    // 2. 兜底置顶 window
    window.scrollTo(0, 0);
  }, 0);
});

export default router;